import React from "react";

const BANKS = ["HDFC Bank", "State Bank of India", "ICICI Bank", "Axis Bank", "Kotak Mahindra", "Bank of Baroda"];

/* Direct bank-alliance trust strip — monochromatic, desaturated "logos" that
   sit at low opacity and resolve to full presence on hover. */
export default function BankStrip({ dark = false }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px 18px", alignItems: "center" }}>
      {BANKS.map((b) => (
        <span
          key={b}
          className="bank-logo"
          style={{
            fontFamily: "var(--serif)",
            fontSize: "1.1rem",
            fontStyle: "italic",
            letterSpacing: "0.01em",
            color: dark ? "var(--paper-ink)" : "var(--ink)",
            padding: "10px 16px",
          }}
        >
          {b}
        </span>
      ))}
      <style>{`
        .bank-logo {
          opacity: 0.4;
          filter: grayscale(1);
          transition: opacity 0.5s var(--ease);
          white-space: nowrap;
        }
        .bank-logo:hover { opacity: 1; }
      `}</style>
    </div>
  );
}
